module.exports = __webpack_public_path__ + "static/media/29BDOS7.42000438.jpg";